import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Y si no cumplo el plan completo?',
  answer: 'Retomas sin culpa. No "recuperas" días perdidos. Cada día empieza de cero. El plan ya está diseñado para eso.'
}, {
  question: '¿Funciona si tengo pareja pero trabaja todo el día?',
  answer: 'Sí. "Sin red de apoyo" significa sin apoyo funcional disponible durante el día. Ajusta el plan a tu realidad.'
}, {
  question: '¿Esto reemplaza atención médica?',
  answer: 'No. Este es un plan práctico de organización y bienestar diario. Incluye un semáforo de alertas para saber cuándo buscar ayuda profesional.'
}, {
  question: '¿En qué formato llega?',
  answer: 'PDF descargable. Lo puedes ver en el celular, tablet o imprimir. Tiene checkboxes interactivos.'
}, {
  question: '¿Sirve sin importar si di a luz natural o por cesárea?',
  answer: 'Sí. El plan es 100% neutral. No importa el tipo de parto ni si estás amamantando o no.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };
  return <section className="w-full bg-gradient-to-b from-lavender-light/20 to-cream py-20 px-6 md:px-8 pt-[50px] pb-[50px]" data-id="element-13">
      <div className="max-w-2xl mx-auto" data-id="element-14">
        <h2 className="text-3xl md:text-4xl font-bold text-text text-center mb-10" data-id="element-15">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-16">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="rounded-2xl border border-lavender/30 bg-white shadow-sm overflow-hidden transition-shadow hover:shadow-md" data-id="element-17">
                <button onClick={() => toggle(idx)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left" aria-expanded={isOpen} data-id="element-18">
                  <span className="text-base md:text-lg font-semibold text-text leading-snug" data-id="element-19">
                    {faq.question}
                  </span>
                  <span className="flex-shrink-0 text-lavender-dark" data-id="element-20">
                    {isOpen ? <ChevronUp className="w-5 h-5" data-id="element-21" /> : <ChevronDown className="w-5 h-5" data-id="element-22" />}
                  </span>
                </button>

                {isOpen && <div className="px-6 pb-5" data-id="element-23">
                    <div className="border-t border-lavender/20 pt-4" data-id="element-24">
                      <p className="text-base text-text/80 leading-relaxed" data-id="element-25">
                        {faq.answer}
                      </p>
                    </div>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}